"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9012],{

/***/ 9012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ GetVillasByKey; },
/* harmony export */   "C2": function() { return /* binding */ GetPaymentStatus; },
/* harmony export */   "CD": function() { return /* binding */ Whatsapp; },
/* harmony export */   "F6": function() { return /* binding */ SendAddVillaForm; },
/* harmony export */   "GX": function() { return /* binding */ CheckPromotioncode; },
/* harmony export */   "Hz": function() { return /* binding */ HomeShortTerms; },
/* harmony export */   "Ld": function() { return /* binding */ GavelLogin; },
/* harmony export */   "Nj": function() { return /* binding */ GetSimilarVillas; },
/* harmony export */   "Nn": function() { return /* binding */ GetAvailability; },
/* harmony export */   "Pu": function() { return /* binding */ GetSliderCaption; },
/* harmony export */   "Pz": function() { return /* binding */ Calculate; },
/* harmony export */   "Qt": function() { return /* binding */ FilterApi; },
/* harmony export */   "Rw": function() { return /* binding */ CreateHashData; },
/* harmony export */   "T4": function() { return /* binding */ GetReservations; },
/* harmony export */   "TI": function() { return /* binding */ GetAvailableReservations; },
/* harmony export */   "Um": function() { return /* binding */ Forgot; },
/* harmony export */   "VX": function() { return /* binding */ AuthLogout; },
/* harmony export */   "Vk": function() { return /* binding */ CheckValletPaymentStatus; },
/* harmony export */   "Wq": function() { return /* binding */ SearchApi; },
/* harmony export */   "_Q": function() { return /* binding */ GetPriceList; },
/* harmony export */   "_c": function() { return /* binding */ SendReservation; },
/* harmony export */   "_l": function() { return /* binding */ CheckPaymentStatus; },
/* harmony export */   "aX": function() { return /* binding */ Register; },
/* harmony export */   "cT": function() { return /* binding */ GetLastMinute; },
/* harmony export */   "dP": function() { return /* binding */ GetPassengerInformation; },
/* harmony export */   "dQ": function() { return /* binding */ AuthMyReservations; },
/* harmony export */   "fw": function() { return /* binding */ server; },
/* harmony export */   "io": function() { return /* binding */ GetProductCategories; },
/* harmony export */   "ji": function() { return /* binding */ GetPaymentData; },
/* harmony export */   "li": function() { return /* binding */ SavePassengerInformation; },
/* harmony export */   "m3": function() { return /* binding */ Login; },
/* harmony export */   "oh": function() { return /* binding */ GetDistance; },
/* harmony export */   "pJ": function() { return /* binding */ GetBlog; },
/* harmony export */   "q5": function() { return /* binding */ SendContact; },
/* harmony export */   "rE": function() { return /* binding */ AuthLogin; },
/* harmony export */   "rt": function() { return /* binding */ SaveBankTransferForm; },
/* harmony export */   "v6": function() { return /* binding */ SendReview; },
/* harmony export */   "xS": function() { return /* binding */ SendOffer; },
/* harmony export */   "yr": function() { return /* binding */ CreatePaymentLink; },
/* harmony export */   "ys": function() { return /* binding */ GetFooterMenu; }
/* harmony export */ });
/* unused harmony exports GetFullScreenMenu, GetPhotosApi, GetPopularVillas, GetStory, GetProductDestinations, PutIycizoResponse, PutIycizoResponseWithoutReservation, UpdatePaymentCallBack, GetPaymentForm, SendSuccessMail, SendSuccessMailWithoutReservation, HomeReviews, SearchBlog, SetRate */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50196);
/* harmony import */ var form_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6230);
/* harmony import */ var form_data__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(form_data__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40993);
/* harmony import */ var react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_toastify_dist_ReactToastify_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _languages_tr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49323);






var server = axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].create */ .ZP.create();
server.defaults.baseURL = "https://api.balayivillasikirala.com.tr";
//Kelime ile arama
var SearchApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(text) {
        var searchMinLength;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchMinLength = _languages_tr__WEBPACK_IMPORTED_MODULE_4__/* .language.searchMinLength */ .d.searchMinLength;
                    if (!(text.length < 3)) {
                        _ctx.next = 3;
                        break;
                    }
                    throw {
                        message: searchMinLength
                    };
                case 3:
                    return _ctx.abrupt("return", server.get("/Search?q=" + text));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SearchApi(text) {
        return _ref.apply(this, arguments);
    };
}();
//FullscreenMenu
var GetFullScreenMenu = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/FullScreenMenu"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetFullScreenMenu() {
        return _ref.apply(this, arguments);
    };
}();
//Detay Fotoğraflar
var GetPhotosApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/Photos?id=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPhotosApi(id) {
        return _ref.apply(this, arguments);
    };
}();
//Footer Menü
var GetFooterMenu = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/FooterMenu"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetFooterMenu() {
        return _ref.apply(this, arguments);
    };
}();
//Arama Motoru
var FilterApi = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var strParams;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    strParams = new URLSearchParams(params).toString();
                    return _ctx.abrupt("return", server.get("/filter?" + strParams));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function FilterApi(params) {
        return _ref.apply(this, arguments);
    };
}();
//Fiyat Hesaplama
var Calculate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var strParams;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    strParams = new URLSearchParams(params).toString();
                    return _ctx.abrupt("return", server.get("/Calculate?" + strParams));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function Calculate(params) {
        return _ref.apply(this, arguments);
    };
}();
//Popüler Villalar
var GetPopularVillas = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var strParams;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    strParams = new URLSearchParams(params).toString();
                    return _ctx.abrupt("return", server.get("/get-popular-villas?" + strParams));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPopularVillas(params) {
        return _ref.apply(this, arguments);
    };
}();
//Key'e göre Villalar
var GetVillasByKey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(key) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/GetVillasByKey?key=" + key));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetVillasByKey(key) {
        return _ref.apply(this, arguments);
    };
}();
//Benzer Villalar
var GetSimilarVillas = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id, destination) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/GetSimilarVillas?id=" + id + "&destination=" + destination));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetSimilarVillas(id, destination) {
        return _ref.apply(this, arguments);
    };
}();
//Detay Fiyat Tablosu
var GetPriceList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id, currency) {
        var start2, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    start2 = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "";
                    return _ctx.abrupt("return", server.get("/PriceList?id=" + id + "&currency=" + currency + "&start2=" + start2));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPriceList(id, currency) {
        return _ref.apply(this, arguments);
    };
}();
//Talep Gönder
var SendReservation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, data) {
        var form_data, strParams;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    form_data = new (form_data__WEBPACK_IMPORTED_MODULE_2___default())();
                    Object.keys(data).forEach(function(key) {
                        return form_data.append(key, data[key]);
                    });
                    strParams = new URLSearchParams(params).toString();
                    return _ctx.abrupt("return", server.post("/SendReservation?" + strParams, form_data));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendReservation(params, data) {
        return _ref.apply(this, arguments);
    };
}();
//Home Story
var GetStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/Story"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetStory() {
        return _ref.apply(this, arguments);
    };
}();
var GetSliderCaption = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/get-slider-caption"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetSliderCaption() {
        return _ref.apply(this, arguments);
    };
}();
var GetProductCategories = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/ProductCategories"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetProductCategories() {
        return _ref.apply(this, arguments);
    };
}();
var GetProductDestinations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/ProductDestinations"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetProductDestinations() {
        return _ref.apply(this, arguments);
    };
}();
var GetAvailability = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(EntityId) {
        var start2, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    start2 = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "";
                    return _ctx.abrupt("return", server.get("/Availability?EntityId=" + EntityId + "&start2=" + start2));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetAvailability(EntityId) {
        return _ref.apply(this, arguments);
    };
}();
var AuthMyReservations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var Action, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    Action = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "Reservations";
                    if (!localStorage.getItem("reservations_auth")) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", server.post("/IsLogin?Action=" + Action, "token=" + localStorage.getItem("reservations_auth")));
                case 3:
                    throw {
                        error: "Not Login"
                    };
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function AuthMyReservations() {
        return _ref.apply(this, arguments);
    };
}();
var AuthLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var Email, ReservationNumber, AuthKey, Token, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    Email = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, ReservationNumber = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null, AuthKey = _args.length > 2 && _args[2] !== void 0 ? _args[2] : null, Token = _args.length > 3 && _args[3] !== void 0 ? _args[3] : null;
                    if (!AuthKey) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", server.post("/Reservations", "AuthKey=" + AuthKey));
                case 3:
                    if (!Token) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", server.post("/Reservations", "token=" + Token));
                case 5:
                    return _ctx.abrupt("return", server.post("/Reservations", "Email=" + Email + "&ReservationNumber=" + ReservationNumber));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function AuthLogin() {
        return _ref.apply(this, arguments);
    };
}();
var GavelLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ReservationNumber, Emlak, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ReservationNumber = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, Emlak = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null;
                    return _ctx.abrupt("return", server.post("/CheckGavelReservation", "ReservationNumber=" + ReservationNumber + "&emlak=" + Emlak));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GavelLogin() {
        return _ref.apply(this, arguments);
    };
}();
var AuthLogout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/Logout", "token=" + localStorage.getItem("reservations_auth")));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function AuthLogout() {
        return _ref.apply(this, arguments);
    };
}();
var GetReservations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/Reservations?token=" + token));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetReservations(token) {
        return _ref.apply(this, arguments);
    };
}();
var GetPaymentData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, id) {
        var agent, ip, config, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    agent = _args.length > 2 && _args[2] !== void 0 ? _args[2] : null, ip = _args.length > 3 && _args[3] !== void 0 ? _args[3] : null;
                    config = {};
                    if (agent) {
                        config.headers = {
                            "User-Agent": agent,
                            CLIENT_IP: ip
                        };
                    }
                    return _ctx.abrupt("return", server.post("/Payment?token=" + token, "id=" + id, config));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPaymentData(token, id) {
        return _ref.apply(this, arguments);
    };
}();
var CreatePaymentLink = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/Vallet?token=" + token, "id=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CreatePaymentLink(token, id) {
        return _ref.apply(this, arguments);
    };
}();
var CreateHashData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/CreateHashData", values));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CreateHashData(values) {
        return _ref.apply(this, arguments);
    };
}();
var GetPaymentStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(h) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/VirtualPosResponse", {
                        h: h
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPaymentStatus(h) {
        return _ref.apply(this, arguments);
    };
}();
var PutIycizoResponse = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, response) {
        var agent, ip, config, strParams, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    agent = _args.length > 2 && _args[2] !== void 0 ? _args[2] : null, ip = _args.length > 3 && _args[3] !== void 0 ? _args[3] : null;
                    config = {
                        responseEncoding: "utf8"
                    };
                    if (agent) {
                        config.headers = {
                            "User-Agent": agent,
                            CLIENT_IP: ip
                        };
                    }
                    strParams = new URLSearchParams(response).toString();
                    return _ctx.abrupt("return", server.post("/IyzicoResponse?token=" + token, strParams, config));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PutIycizoResponse(token, response) {
        return _ref.apply(this, arguments);
    };
}();
var PutIycizoResponseWithoutReservation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(basketid, response) {
        var config, strParams;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    config = {
                        responseEncoding: "utf8"
                    };
                    strParams = new URLSearchParams(response).toString();
                    return _ctx.abrupt("return", server.post("/IyzicoResponseWithoutReservation", strParams, config));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function PutIycizoResponseWithoutReservation(basketid, response) {
        return _ref.apply(this, arguments);
    };
}();
var UpdatePaymentCallBack = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/IyzicoCallbackUpdate", "conversationId=" + data.conversationId + "&data=" + JSON.stringify(data)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function UpdatePaymentCallBack(data) {
        return _ref.apply(this, arguments);
    };
}();
var GetPaymentForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/PaymentForm?_=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPaymentForm(id) {
        return _ref.apply(this, arguments);
    };
}();
var SendSuccessMail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/PaymentSuccess?_=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendSuccessMail(id) {
        return _ref.apply(this, arguments);
    };
}();
var SendSuccessMailWithoutReservation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/SendSuccessMailWithoutReservation?_=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendSuccessMailWithoutReservation(id) {
        return _ref.apply(this, arguments);
    };
}();
var CheckPaymentStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/CheckPayment?_=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CheckPaymentStatus(id) {
        return _ref.apply(this, arguments);
    };
}();
var CheckValletPaymentStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/CheckValletPayment?_=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CheckValletPaymentStatus(id) {
        return _ref.apply(this, arguments);
    };
}();
var GetPassengerInformation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/PassengerInformation?token=" + token + "&_=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetPassengerInformation(token, id) {
        return _ref.apply(this, arguments);
    };
}();
var GetLastMinute = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/LastMinute"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetLastMinute() {
        return _ref.apply(this, arguments);
    };
}();
var GetDistance = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/Distance?EntityId=" + id));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetDistance(id) {
        return _ref.apply(this, arguments);
    };
}();
var HomeReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/HomeReviews"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function HomeReviews() {
        return _ref.apply(this, arguments);
    };
}();
var Whatsapp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/Whatsapp"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function Whatsapp() {
        return _ref.apply(this, arguments);
    };
}();
var HomeShortTerms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/HomeShortTerms"));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function HomeShortTerms() {
        return _ref.apply(this, arguments);
    };
}();
var SearchBlog = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(text) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/Routing?url=blog-kesfet&search=" + text));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SearchBlog(text) {
        return _ref.apply(this, arguments);
    };
}();
var GetBlog = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page, SearchText) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.get("/GetBlog?page=" + page + "&search=" + SearchText));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetBlog(page, SearchText) {
        return _ref.apply(this, arguments);
    };
}();
var SetRate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(rate) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/announcement", "rate=" + rate));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SetRate(rate) {
        return _ref.apply(this, arguments);
    };
}();
var SavePassengerInformation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, id, data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/PassengerInformation?token=" + token + "&_=" + id, "data=" + JSON.stringify(data)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SavePassengerInformation(token, id, data) {
        return _ref.apply(this, arguments);
    };
}();
var SaveBankTransferForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, id, data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/SaveBankTransferForm?token=" + token + "&_=" + id, "data=" + JSON.stringify(data)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SaveBankTransferForm(token, id, data) {
        return _ref.apply(this, arguments);
    };
}();
var SendOffer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/SendOffer", "data=" + JSON.stringify(data)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendOffer(data) {
        return _ref.apply(this, arguments);
    };
}();
var SendReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/SendReview", "data=" + JSON.stringify(data)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendReview(data) {
        return _ref.apply(this, arguments);
    };
}();
var SendContact = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/SendContact", "data=" + JSON.stringify(data)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendContact(data) {
        return _ref.apply(this, arguments);
    };
}();
var SendAddVillaForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/SendAddVillaForm", data));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function SendAddVillaForm(data) {
        return _ref.apply(this, arguments);
    };
}();
var CheckPromotioncode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/CheckPromotioncode", data));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function CheckPromotioncode(data) {
        return _ref.apply(this, arguments);
    };
}();
var GetAvailableReservations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var form_data;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    form_data = new (form_data__WEBPACK_IMPORTED_MODULE_2___default())();
                    Object.keys(data).forEach(function(key) {
                        return form_data.append(key, data[key]);
                    });
                    return _ctx.abrupt("return", server.post("/KiralamaTakvimi/AvailableReservations", form_data));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function GetAvailableReservations(data) {
        return _ref.apply(this, arguments);
    };
}();
var Login = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/login", data));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function Login(data) {
        return _ref.apply(this, arguments);
    };
}();
var Register = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, step) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/register", data, {
                        params: {
                            step: step
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function Register(data, step) {
        return _ref.apply(this, arguments);
    };
}();
var Forgot = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, step) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", server.post("/forgot", data, {
                        params: {
                            step: step
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function Forgot(data, step) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);